import React, { useContext } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { SecondaryButton, PrimaryButton } from "../buttons";
import Modal from "../Modal";
import Text from "../edu/Text";
import { FormContext } from "../../context/form-context";

import "./SaveEntryModal.scss";

const SaveEntryModal = ({
  saveEntryModalShown = false,
  hideTrackerModals = () => {},
  showPreviousModal = () => {}
}) => {
  const { t } = useTranslation();
  const formContext = useContext(FormContext);

  const onSubmit = () => {
    if (formContext?.functions?.onSubmit) {
      formContext.functions.onSubmit(formContext.formValues);
    }
  };

  return (
    <Modal
      isOpen={saveEntryModalShown}
      showCloseButton={false}
      onRequestClose={hideTrackerModals}
    >
      <h5 className="saveentry-modal__title">{t("tracker.saveEntryTitle")}</h5>
      
      <Text className="saveentry-modal__text">
        {t("tracker.saveEntryDescription")}
      </Text>
      
      <Text className="saveentry-modal__text">
        {t("tracker.saveEntryCaption")}
      </Text>

      <div className="saveentry-modal__footer">
        <PrimaryButton
          colorScheme="blue"
          label={t("tracker.rejectDelete")}
          onClick={showPreviousModal}
        />
        <SecondaryButton
          colorScheme="red"
          label={t("tracker.save")}
          onClick={onSubmit}
        />
      </div>
    </Modal>
  );
};

SaveEntryModal.propTypes = {
  saveEntryModalShown: PropTypes.bool,
  hideTrackerModals: PropTypes.func,
  showPreviousModal: PropTypes.func
};

export default SaveEntryModal;
